import { Modal } from 'antd';
import axios from 'axios';

// const codeMessage = {
//   200: 'OK',
//   201: 'Created',
//   202: 'Accepted',
//   204: 'No Content',
//   400: 'Bad Request',
//   401: '로그인 세션 만료',
//   403: 'Forbidden',
//   404: 'Not Found',
//   406: 'Not Acceptable',
//   410: 'Gone',
//   422: 'Unprocessable Entity',
//   500: 'Internal Server Error',
//   502: 'Bad Gateway',
//   503: 'Service Unavailable',
//   504: 'Gateway Timeout',
// };

const sessionAliveCode = [200, 201, 202, 204];

let sessionAlive = false;
let warnTimeout;
let logoutTimeout;

function sessionEvent() {
  sessionAlive = true;
}

function addSessionEvent() {
  ['click', 'scroll', 'keypress'].forEach((event) => {
    window.addEventListener(event, sessionEvent);
  });

  window.addEventListener('beforeunload', () => {
    if (
      localStorage.getItem('portalClose') !== 'true' &&
      localStorage.getItem('autoLogin') !== 'true'
    ) {
      // 토큰의 expire를 3초로 변경
      document.cookie = `${document.cookie};expires=${new Date(
        new Date().getTime() + 3 * 1000,
      ).toUTCString()};path=/portal`;

      localStorage.setItem('portalClose', true);
    }
  });
}

function removeSessionEvent() {
  ['click', 'scroll', 'keypress'].forEach((event) => {
    window.removeEventListener(event, sessionEvent);
  });
}

function clearSessionTimeout() {
  if (warnTimeout) clearTimeout(warnTimeout);
  if (logoutTimeout) clearTimeout(logoutTimeout);
}

async function updateSession() {
  const res = await axios.get('/portal/api/auth');
  // eslint-disable-next-line no-use-before-define
  sessionTimeout((res.data.expires - 30) * 1000, res.data.expires * 1000);

  sessionAlive = false;
}

function doLogout(history) {
  document.cookie = 'x_auth=; path=/portal; max-age=0';
  localStorage.removeItem('userId');
  localStorage.removeItem('username');
  localStorage.removeItem('autoLogin');
  localStorage.setItem('autoConnect', true);

  if (history) {
    history.push('/auth/login');
  } else {
    // XXX request()에서 HTTP-401 오류가 나는 경우 history 객체가 없으므로 다음과 같이 무식하게..
    window.location = '/portal/auth/login';
  }
}

async function destroySession() {
  sessionAlive = false;
  removeSessionEvent();
  clearSessionTimeout();

  doLogout();
}

function sessionTimeout(warnTime, logoutTime) {
  clearSessionTimeout();

  warnTimeout = setTimeout(() => {
    removeSessionEvent();

    Modal.confirm({
      title: '세션 만료 안내',
      content: '세션이 곧 만료됩니다. 연장하시겠습니까?',
      okText: '연장',
      cancelText: '로그아웃',
      onOk: () => {
        clearSessionTimeout();
        updateSession();
        addSessionEvent();
      },
      onCancel: async () => {
        await axios.post('/portal/api/auth/delete');
        destroySession();
      },
    });
  }, warnTime);

  logoutTimeout = setTimeout(async () => {
    Modal.destroyAll();
    await axios.post('/portal/api/auth/delete');
    destroySession();
  }, logoutTime);
}

/*
 * 1분마다 한 번씩 sessionArrive flag를 확인하여 세션을 연장해주거나 만료시킴
 */
function startSessionCheck() {
  setInterval(() => {
    // api call
    if (sessionAlive) {
      updateSession();
    }
  }, 60 * 1000);
}

/*
 * fn: axios.(get | post | put | delete)
 */
function withErrorHandler(fn) {
  return async (...args) => {
    try {
      // Success
      const res = await fn(...args);
      return res;
    } catch (err) {
      if (err.response) {
        const { status } = err.response;

        if (status === 401) {
          // 로그인 페이지에 있지 않으면 인증 실패 창을 띄우고 로그인 페이지로 간다
          if (!document.location.href.split('?')[0].endsWith('/auth/login')) {
            sessionAlive = false;
            removeSessionEvent();
            clearSessionTimeout();

            Modal.warning({
              title: '인증 실패',
              content: '로그인 세션이 만료되었거나 패스워드가 변경되었을 수 있습니다.',
              onOk: () => {
                doLogout();
              },
            });
          }
        } else {
          const msg = err.response.data?.message ? `${err.response.data.message}` : '';

          if (msg) {
            Modal.error({
              title: `잘못된 요청 ${status}`,
              content: `${msg}`,
            });
          }
        }
      } else {
        // eslint-disable-next-line no-console
        console.error(err);
      }

      throw err;
    }
  };
}

async function request(url, payload, method) {
  const res = await withErrorHandler(axios[method])(url, payload);

  // logout 일때는 현재 돌고 있는 세션 만료를 위한 settimeout 제거 및 세션 이벤트 제거
  if (url === '/portal/api/auth/delete') {
    destroySession();
    return res;
  }

  if (sessionAliveCode.includes(res?.status)) {
    /*
     * 새로 고침 시 event가 떨어지기 때문에 호출
     * addEventListener() 메서드는 지정한 이벤트 유형의
     * EventTarget 수신기 리스트에 EventListener를 구현한 함수 또는 객체를 추가하는 방식으로 동작합니다.
     * 추가하려는 함수 또는 객체가 이미 수신기 리스트에 포함되어 있는 경우에는 추가하지 않으므로 수신기는 중복으로 등록되지 않습니다
     * https://developer.mozilla.org/ko/docs/Web/API/EventTarget/addEventListener
     */
    if (localStorage.getItem('userId') && !url.startsWith('/portal/api/session/vdgroups/')) {
      sessionAlive = true;
      addSessionEvent();
    }
  }
  return res;
}

['get', 'post', 'delete', 'put', 'patch'].forEach(
  // eslint-disable-next-line no-return-assign
  (method) => (request[method] = (url, payload) => request(url, payload, method)),
);

startSessionCheck();

export default request;
